/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsRuler: {
  name: 'ruler';
  data: string;
} = {
  name: 'ruler',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.146.646a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1 0 .708l-10.5 10.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 0 1 0-.708l10.5-10.5ZM1.707 11.5 4.5 14.293 14.293 4.5 11.5 1.707 8.457 4.75l1.897 1.896a.5.5 0 0 1-.708.708L7.75 5.457 6.457 6.75l.897.896a.5.5 0 1 1-.708.708l-.896-.897L4.457 8.75l1.897 1.896a.5.5 0 0 1-.708.708L3.75 9.457 1.707 11.5ZM11.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
